import { useQuery as r } from "@tanstack/react-query";
import o from "./course-categories.api.js";
import { teachurKeys as s } from "../../constants/teachurKeys.js";
const n = (e) => r({
  queryKey: s.courseCategories.list(),
  queryFn: async () => (await o.getAll()).data,
  ...e
});
export {
  n as useGetCourseCategoriesQuery
};
